import React from 'react';
import CheckboxIcon from 'assets/svgs/common/checkbox.svg';
import CheckedCheckboxIcon from 'assets/svgs/common/checkbox-checked.svg';
import './style.scss';

export default function Checkbox(props) {
  const inputProps = {
    className: `${props.className || ''}`,
    value: props.value || '',
    type: 'checkbox',
    onChange: props.handleChange,
    checked: props.checked || '',
  };

  if (props.validate) {
    inputProps.onBlur = (event) => {
      props.validate(event.target.value);
    };
  }

  return (
    <span
      key={props.key}
      className={`${
        props.validationError ? 'check_box invalid' : 'check_box'
      } ${props.className || ''}`}
    >
      <input {...inputProps} />
      <img
        src={props.checked ? CheckedCheckboxIcon : CheckboxIcon}
        alt=""
        height={20}
        width={20}
      />
      {props.validationError && (
        <p className="input-validation-error mt-1">{props.validationError}</p>
      )}
    </span>
  );
}
